import type { TableData } from '@repo/commons/models'
import { toLeverFormValue } from '@repo/commons/utils'
import type { LeverFormValues } from './types.js'

export const toLeverFormValues = (lever?: TableData | null): LeverFormValues => ({
	leverId: lever?.id ?? '',
	defaultValue: toLeverFormValue(lever?.defaultValue)
})
